/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams';

export class StartSparkJobInput {
  /**
  * The ID of the Spark engine to run the job on
  */
  'sparkEngineId': string;
  /**
  * The name of the Spark job
  */
  'name': string;
  /**
  * Job timeout in seconds
  */
  'jobTimeout'?: number;
  'retryPolicy'?: SparkJobRetryPolicy | null;
  'sparkSubmitParams': SparkJobSparkSubmitParams;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sparkEngineId",
      "baseName": "sparkEngineId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "jobTimeout",
      "baseName": "jobTimeout",
      "type": "number",
      "format": ""
    },
    {
      "name": "retryPolicy",
      "baseName": "retryPolicy",
      "type": "SparkJobRetryPolicy",
      "format": ""
    },
    {
      "name": "sparkSubmitParams",
      "baseName": "sparkSubmitParams",
      "type": "SparkJobSparkSubmitParams",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StartSparkJobInput.attributeTypeMap;
  }

  public constructor() {
  }
}

